module.exports = require('./lib/type');



//////////////////
// WEBPACK FOOTER
// ./~/deep-eql/~/type-detect/index.js
// module id = 46
// module chunks = 1 3